import React from 'react';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import DemeritEducationReservationSuccessBottomSheet from '@di-shared/features/public-service/demerit-education/DemeritEducationReservationSuccessBottomSheet';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 500;

export default function DemeritEducationReservationSuccessBottomSheetPage() {
  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <DemeritEducationReservationSuccessBottomSheet />
    </BottomSheetWebViewWrapper>
  );
}
